import React from "react";
import { Box, Grid, IconButton, InputAdornment, MenuItem, Paper, Typography } from "@mui/material";
import { Email } from "@mui/icons-material";
import { FormHandles } from "@unform/core";

import { LoadingComp } from "../../../../../shared/components/loading/Loading";
import { VForm, VTextField } from "../../../../../shared/forms";
import { VMaskTextField } from "../../../../../shared/forms/VMaskTextField";
import { ISimulateEditLocator } from "../../../../../shared/services/api/proposal/ProposalEditService";
import { IProposalList } from "../../../../../shared/services/api/proposal/ProposalService";

interface LocatorTabProps {
	formRef: React.RefObject<FormHandles>;
	isLoading: boolean;
	documentType?: string;
	setDocumentType: (value: string) => void;
	rows?: IProposalList;
	onSubmit: (dados: ISimulateEditLocator) => void;
	onBlurDocument: (value: string) => void;
}

export const LocatorTab: React.FC<LocatorTabProps> = ({
	formRef,
	isLoading,
	documentType,
	setDocumentType,
	rows,
	onSubmit,
	onBlurDocument,
}) => {
	return (
		<Box>
			{isLoading && <LoadingComp isopen />}
			<VForm id="formIdLocatorChange" ref={formRef} onSubmit={onSubmit} onPointerEnterCapture={''} onPointerLeaveCapture={''} placeholder={''}>
				<Box margin={0} display="flex" flexDirection="column" component={Paper} variant="elevation" elevation={0}>
					<Grid container item direction="column" padding={2} spacing={2}>
						<Grid container item direction="row" spacing={2}>
							<Grid item xs={12}>
								<Typography variant="h6" color={"primary"}>
									Alteração do Locador
								</Typography>
							</Grid>

							<Grid container item direction="row" spacing={2}>
								<Grid item xs={12} md={4}>
									<VMaskTextField
										fullWidth
										label="Documento"
										name="lessorCpf"
										disabled={isLoading}
										mask={documentType == "legal" ? "cnpj" : "cpf"}
										onBlur={(e) => onBlurDocument(e.target.value)}
									/>
								</Grid>

								<Grid item xs={12} md={4}>
									<VTextField fullWidth label="Nome" name="lessorName" disabled={isLoading} />
								</Grid>

								<Grid item xs={12} md={4}>
									<VTextField fullWidth label="Data de nascimento" name="lessorBirthDate" disabled={isLoading} type="date" />
								</Grid>
							</Grid>

							<Grid container item direction="row" spacing={2}>
								<Grid item xs={12} md={4}>
									<VMaskTextField fullWidth label="Celular" name="lessorPhone" disabled={isLoading} mask="cell" />
								</Grid>
								<Grid item xs={12} md={4}>
									<VMaskTextField fullWidth label="Telefone" name="lessorMobilePhone" disabled={isLoading} mask="cell" />
								</Grid>
								<Grid item xs={12} md={4}>
									<VTextField
										fullWidth
										label="E-mail"
										name="lessorEmail"
										disabled={isLoading}
										trimEmptySpaces={true}
										InputProps={{
											endAdornment: (
												<InputAdornment position="end">
													<IconButton aria-label="toggle password visibility" edge="end">
														<Email />
													</IconButton>
												</InputAdornment>
											),
										}}
									/>
								</Grid>
							</Grid>

							<Grid container item direction="row" spacing={2}>
								<Grid item xs={12} md={2}>
									<VTextField
										fullWidth
										label="Tipo de Locador"
										name="lessorTypePerson"
										disabled={isLoading}
										onChange={(e: any) => {
											setDocumentType(e.target.value);
											formRef.current?.reset();
											formRef.current?.setData({
												lessorTypePerson: e.target.value,
												lessorName: rows?.lessorName,
												lessorCpf: rows?.lessorCpf,
												lessorBirthDate: rows?.lessorBirthDate,
												lessorEmail: rows?.lessorEmail,
												lessorPhone: rows?.lessorPhone,
												lessorMobilePhone: rows?.lessorMobilePhone,
												obs: rows?.obs,
											});
										}}
										select
									>
										<MenuItem value={"physical"}>Fisica</MenuItem>
										<MenuItem value={"legal"}>Juridica</MenuItem>
									</VTextField>
								</Grid>

								<Grid item xs={12} md={10}>
									<VTextField fullWidth label="Motivo" name="obs" disabled={isLoading} type="text" />
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Box>
			</VForm>
		</Box>
	);
};
